import axios from "axios";
import { getSession } from "../customHooks/index";

const API_Path = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const defaultHeaders = {
  "Content-Type": "application/json",
};

// Patterns that can execute code in a browser context.
// Targets script injection, JS/VBS URI schemes, inline event handlers,
// executable-content tags, and data: URIs with executable MIME types.
const XSS_PATTERNS = [
  /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
  /javascript\s*:/gi,
  /vbscript\s*:/gi,
  /on\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*)/gi,
  /<\s*\/?\s*(?:iframe|object|embed|link|meta|base)\b[^>]*/gi,
  /data\s*:\s*(?:text\/html|application\/javascript)/gi,
];

const sanitizeString = (value) =>
  XSS_PATTERNS.reduce((str, pattern) => str.replace(pattern, ""), value);

// Recursively strips XSS vectors from all string fields in a payload.
// FormData (file uploads) and non-string primitives pass through unchanged.
const sanitizePayload = (data) => {
  if (data === null || data === undefined) return data;
  if (data instanceof FormData) return data;
  if (typeof data === "string") return sanitizeString(data);
  if (Array.isArray(data)) return data.map(sanitizePayload);
  if (typeof data === "object") {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [key, sanitizePayload(value)])
    );
  }
  return data;
};

const sendRequest = async (method, url, data, headers = {}) => {
  const apiUrl = API_Path + url;
  const sanitizedData = sanitizePayload(data);

  try {
    const response = await axios({
      method,
      url: apiUrl,
      data: sanitizedData,
      headers: { Authorization: `Bearer ${getSession("token")}`, ...headers },
    });
    return { status: response?.status, data: response?.data };
  } catch (error) {
    return { status: error?.response?.status, data: error?.response?.data };
  }
};

export const doPost = async (url, body, headers) => sendRequest("post", url, body, { ...defaultHeaders, ...headers });
export const doGet = async (url, headers) => sendRequest("get", url, null, headers);
export const doPatch = async (url, body, headers) => sendRequest("patch", url, body, headers);
export const doDelete = async (url, headers) => sendRequest("delete", url, null, headers);


